type TimeInterval = MillisecondsCount;

export function nextPaint(timeout: TimeInterval): TimeInterval {
  const REPAINT_DURATION_MS: TimeInterval = 16;
  return timeout + REPAINT_DURATION_MS;
}
